export const DATE_PICKER_FORMAT_1 = "dd/MM/yyyy";
export const DATE_PICKER_FORMAT_2 = "MM/yyyy";
